import {Prettify} from '@/common/Utils.common';
import {FileNameAndId} from '@/services/api-clients';

export default interface DigitalDocumentQueueSenderTransferProtocolFormModel {
  vehicleRentDateTime: string;
  carBody: CleanlinessTypeEnum | null;
  interior: CleanlinessTypeEnum | null;
  equipmentItems: EquipmentItem[],
  primaryFuelPercent: number;
  secondaryFuelPercent: number;
  mileage: number;
  additionalInformation: string;
  conditionItems: Condition[];
  vehiclePhotos: VehiclePhoto[];
  thermalBackpack: ThermalBackpackDto | null;
  taxiLamp: TaxiLampEnum | null;
  isBreakFluidLevelCorrect: boolean | null;
  isBreakPadsConditionCorrect: boolean | null;
  isCoolantLevelCorrect: boolean | null;
  isAllBulbsWorking: boolean | null;
}

export interface VehiclePhoto {
  mediumId: number;
  fileName: string;
  vehicleViewType: VehicleViewTypeEnum;
}


export interface EquipmentItem {
  type: EquipmentTypeEnum,
  additionalInformation: string,
}

export interface Condition {
  part: PartTypeEnum | null;
  customPart: string;
  damageItems: PartDamageTypeEnum[];
  media: FileNameAndId[];
}
type ConditionTempId = Condition & { tempId: string }

export type ConditionCreate = Prettify<ConditionTempId>;

interface MediaFile extends FileNameAndId {
  fileUrl: string;
}

export interface ConditionWithMediaFile {
  part: PartTypeEnum | null;
  customPart: string;
  damageItems: PartDamageTypeEnum[];
  media: MediaFile[];
}

type ConditionTempIdWithMediaFile = ConditionWithMediaFile & { tempId: string };

export type ConditionCreateWithMediaFile = Prettify<ConditionTempIdWithMediaFile>;

export interface ThermalBackpackDto {
  brand: ThermalBackpackBrandEnum | null;
  condition: ThermalBackpackConditionEnum | null;
}

export enum CleanlinessTypeEnum {
  Clean = 1,
  Dirty = 2
}

export enum EquipmentTypeEnum {
  Keys = 1,
  VehicleLiabilityInsurance = 2,
  Manual = 3,
  BoltTaxiLamp = 4,
  FireExtinguisher = 5,
  RepairKit = 6,
  WarningTriangle = 7,
  PhoneHolder = 8,
  LPGAdapter = 9,
  TaxiLicense = 10,
  CarFirstAidKit = 11,
  AMICFleetCard = 12,
  FenderPresence = 13,
  Flashlights = 14,
  FoldingLock = 15,
  WaterProofPhoneBag = 16,
  ChargedBattery = 17,
  Mirrors = 18,
  Helmet = 19,
  Gloves = 20,
  MotorCover = 21,
  Lights = 22,
  VehicleCharger = 23,
  ChargingCable240V400V = 24,
}


export enum PartTypeEnum {
  FrontBumper = 1,
  FrontLeftWheel = 2,
  FrontLeftFender = 3,
  FrontLeftDoor = 4,
  LeftSidePanel = 5,
  RearLeftDoor = 6,
  RearLeftFender = 7,
  RearLeftWheel = 8,
  RearBumper = 9,
  RearRightFender = 10,
  RearRightWheel = 11,
  RearRightDoor = 12,
  RightSidePanel = 13,
  FrontRightDoor = 14,
  FrontRightFender = 15,
  FrontRightWheel = 16,
  Hood = 17,
  FrontWindshield = 18,
  Roof = 19,
  RearWindshield = 20,
  Trunk = 21,
  FrontWheel = 22,
  FrontFender = 23,
  Seat = 24,
  Frame = 25,
  RearWheel = 26,
  RearFender = 27,
  SteeringWheel = 28
}

export enum BikePartTypeEnum {
  Trunk = 21,
  FrontWheel = 22,
  FrontFender = 23,
  Seat = 24,
  Frame = 25,
  RearWheel = 26,
  RearFender = 27,
  SteeringWheel = 28
}

export enum PartDamageTypeEnum {
  Scratch = 1,
  Chip = 2,
  Dent = 3,
  Crack = 4,
  Missing = 5,
  Damage = 6,
  Wear = 7
}

export enum VehicleViewTypeEnum {
  //universal
  Front = 1,
  LeftSide = 2,
  RightSide = 3,
  Back = 4,
  Interior = 5,
  Other = 6,
  Dashboard = 7,
  CoolantLevel = 10,

  //bike/scooter
  DashboardCloseup = 8,
  BikeSeat = 9,

  //ebike
  Handlebar = 18,
  MileageScreen = 19,
  BikeKeys = 20,
  RearBikeTire = 21,
  RearBikeWheelWithChain = 22,

  //car
  LeftFront = 11,
  RightFront = 12,
  LeftRear = 13,
  RightRear = 14,
  DriverSeat = 15,
  BackSeat = 16,
  MiddleAndPassengerSeat = 17
}

export enum ThermalBackpackConditionEnum
{
  New = 1,
  Used = 2,
}

export enum TaxiLampEnum
{
  Wired = 1,
  WirelessWithRemote = 2,
  BoltBranded = 3,
  UberBranded = 4,
  FreeNowBranded = 5,
}

export enum ThermalBackpackBrandEnum
{
  UberEats = 1,
  BoltFood = 2,
  Other = 3,
}
